import { useState, useRef, useEffect } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

// Wraps a Leaflet map ref-div with a maximize toggle. When maximized it becomes a
// draggable half-screen window (drag the title bar to reposition).
export function MapShell({ children, heightClass = "h-64", onToggle, testid = "map" }) {
  const [full, setFull] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const dragRef = useRef(null);
  useEffect(() => { onToggle && onToggle(full); }, [full]); // eslint-disable-line react-hooks/exhaustive-deps

  const enter = () => {
    const mobile = window.innerWidth < 768;
    setPos(mobile ? { x: 12, y: 12 } : { x: Math.round(window.innerWidth * 0.24), y: Math.round(window.innerHeight * 0.14) });
    setFull(true);
  };

  const startDrag = (e) => {
    const p = e.touches ? e.touches[0] : e;
    dragRef.current = { sx: p.clientX, sy: p.clientY, ox: pos.x, oy: pos.y };
    const move = (ev) => { const q = ev.touches ? ev.touches[0] : ev; setPos({ x: dragRef.current.ox + (q.clientX - dragRef.current.sx), y: dragRef.current.oy + (q.clientY - dragRef.current.sy) }); };
    const end = () => { window.removeEventListener("mousemove", move); window.removeEventListener("mouseup", end); window.removeEventListener("touchmove", move); window.removeEventListener("touchend", end); };
    window.addEventListener("mousemove", move); window.addEventListener("mouseup", end);
    window.addEventListener("touchmove", move, { passive: false }); window.addEventListener("touchend", end);
  };

  return (
    <div
      className={full ? "fixed z-[2000] flex flex-col overflow-hidden rounded-xl border border-slate-300 bg-white shadow-2xl" : `relative isolate w-full ${heightClass}`}
      style={full ? { left: pos.x, top: pos.y, width: "min(52vw, calc(100vw - 24px))", height: "min(62vh, calc(100vh - 24px))" } : undefined}>
      {full && (
        <div key="hdr" onMouseDown={startDrag} onTouchStart={startDrag} className="flex shrink-0 cursor-move select-none items-center justify-between bg-slate-900 px-3 py-2 text-xs font-semibold text-white">
          <span>Versleep om te verplaatsen</span>
          <button type="button" data-testid={`${testid}-minimize`} onClick={() => setFull(false)} className="rounded-lg p-1 hover:bg-white/10"><Minimize2 className="h-4 w-4" /></button>
        </div>
      )}
      <div key="body" className={full ? "relative flex-1" : "contents"}>{children}</div>
      {!full && (
        <button type="button" data-testid={`${testid}-maximize`} onClick={enter} title="Vergroten"
          className="absolute right-3 bottom-3 z-[1001] flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white/95 text-slate-700 shadow hover:bg-white">
          <Maximize2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
